<span>
    <div class="row mobile-view" *ngIf="mobileView">
        <div
            class="view1"
            [ngClass]="{
                'slide-view-in': view === 1,
                'slide-view-out': view !== 1
            }"
        >
            <div
                class="item account-title"
                (click)="setView(2, 'Account')"
                *ngIf="userService.isLoggedIn()"
            >
                <span class="item-title">Account</span>
                <div class="arrow-right">
                    <app-icon [type]="'Arrow-right'"></app-icon>
                </div>
            </div>

            <div class="item" (click)="setView(2, 'Subjects')">
                <span class="item-title">Subjects</span>
                <div class="arrow-right">
                    <app-icon [type]="'Arrow-right'"></app-icon>
                </div>
            </div>

            <div class="item" (click)="setView(2, 'Grades')">
                <span class="item-title">Grades</span>
                <div class="arrow-right">
                    <app-icon [type]="'Arrow-right'"></app-icon>
                </div>
            </div>

            <div class="item">
                <a href="/standards/0/" class="{{ gtmPrefix + 'standards' }}">
                    Standards
                </a>
            </div>

            <div class="item">
                <a
                    [routerLink]="['/student']"
                    class="{{ gtmPrefix + 'standards' }}"
                >
                    For Students
                    <em class="fas fa-external-link-alt"></em>
                </a>
            </div>
        </div>

        <div
            class="view2"
            [ngClass]="{
                'slide-view-in': view === 2,
                'slide-view-out': view !== 2
            }"
        >
            <div class="item back-btn" (click)="setView(1)">
                <div class="arrow-left">
                    <app-icon [type]="'Arrow-left'"></app-icon>
                </div>
                <span class="item-title">Back</span>
            </div>
            <div class="item subject-title">
                {{ mobileSubjectTitle }}
            </div>
            <span *ngIf="mobileSubjectTitle === 'Subjects'">
                <div
                    class="item"
                    *ngFor="let discipline of disciplines"
                    (click)="setView(3, discipline.title, discipline)"
                >
                    <span
                        class="item-title"
                        [ngClass]="getColorClass(discipline)"
                        >{{ discipline.title }}</span
                    >
                    <div class="arrow-right">
                        <app-icon [type]="'Arrow-right'"></app-icon>
                    </div>
                </div>
            </span>

            <span class="grades" *ngIf="mobileSubjectTitle === 'Grades'">
                <div class="item">
                    <a
                        [routerLink]="['/', 'grades', 'prek']"
                        class="{{ gtmPrefix + 'grade-band' }}"
                        [attr.data-gtmlabel]="'PreK'"
                    >
                        PreK
                    </a>
                </div>
                <div class="item">
                    <a
                        [routerLink]="['/', 'grades', 'early-elementary']"
                        class="{{ gtmPrefix + 'grade-band' }}"
                        [attr.data-gtmlabel]="'Early Elementary'"
                    >
                        Early Elementary
                    </a>
                </div>
                <div class="item">
                    <a
                        [routerLink]="['/', 'grades', 'upper-elementary']"
                        class="{{ gtmPrefix + 'grade-band' }}"
                        [attr.data-gtmlabel]="'Upper Elementary'"
                    >
                        Upper Elementary
                    </a>
                </div>
                <div class="item">
                    <a
                        [routerLink]="['/', 'grades', 'middle-school']"
                        class="{{ gtmPrefix + 'grade-band' }}"
                        [attr.data-gtmlabel]="'Middle School'"
                    >
                        Middle School
                    </a>
                </div>
                <div class="item">
                    <a
                        [routerLink]="['/', 'grades', 'high-school']"
                        class="{{ gtmPrefix + 'grade-band' }}"
                        [attr.data-gtmlabel]="'High School'"
                    >
                        High School
                    </a>
                </div>
            </span>

            <span class="account" *ngIf="mobileSubjectTitle === 'Account'">
                <div *ngIf="!isStudent" class="item">
                    <a
                        href="/dashboard/"
                        class="{{ gtmPrefix + 'dashboard' }}"
                        [attr.data-gtmlabel]="'Dashboard'"
                        >Dashboard</a
                    >
                </div>
                <div class="item">
                    <a
                        href="/favorites/"
                        class="{{ gtmPrefix + 'favorites' }}"
                        [attr.data-gtmlabel]="'Favorites'"
                        >Favorites</a
                    >
                </div>
                <div class="item">
                    <a
                        href="/folders/"
                        class="{{ gtmPrefix + 'folders' }}"
                        [attr.data-gtmlabel]="'Folders'"
                        >Folders</a
                    >
                </div>
                <div *ngIf="!isStudent" class="item">
                    <a
                        href="/tools/rosters/assignments"
                        class="{{ gtmPrefix + 'assignments' }}"
                        [attr.data-gtmlabel]="'Assignments'"
                        >Assignments</a
                    >
                </div>
                <div *ngIf="!isStudent" class="item">
                    <a
                        href="/tools/rosters/"
                        class="{{ gtmPrefix + 'rosters' }}"
                        [attr.data-gtmlabel]="'Classes'"
                        >Classes</a
                    >
                </div>
                <div *ngIf="!isStudent" class="item">
                    <a
                        href="/tools/"
                        class="{{ gtmPrefix + 'tools' }}"
                        [attr.data-gtmlabel]="'Tools'"
                        >Tools</a
                    >
                </div>
                <div *ngIf="!isStudent" class="item">
                    <a
                        href="/profile/"
                        class="{{ gtmPrefix + 'profile' }}"
                        [attr.data-gtmlabel]="'Profile'"
                        >Profile</a
                    >
                </div>
                <div class="item">
                    <a
                        [href]="userService.getLogoutUrl()"
                        class="{{ gtmPrefix + 'logout' }}"
                        [attr.data-gtmlabel]="'Logout'"
                        >Logout</a
                    >
                </div>
            </span>
        </div>

        <div
            class="view3"
            [ngClass]="{
                'slide-view-in': view === 3,
                'slide-view-out': view !== 3
            }"
        >
            <div class="item back-btn" (click)="setView(2, 'Subjects')">
                <div class="arrow-left">
                    <app-icon [type]="'Arrow-left'"></app-icon>
                </div>
                <span class="item-title">Back</span>
            </div>
            <div *ngIf="view3Discipline" class="item subject-title">
                <a
                    [routerLink]="view3Discipline.getBrowseURL()"
                    [ngClass]="getColorClass(view3Discipline)"
                    >{{ mobileSubjectTitle }}</a
                >
            </div>
            <span *ngIf="view3Discipline">
                <div
                    class="item"
                    *ngFor="let child of getAvailableSubjects(view3Discipline)"
                >
                    <a
                        [routerLink]="child.getBrowseURL()"
                        [ngClass]="getColorClass(view3Discipline)"
                        class="{{
                            getColorClassString(view3Discipline) +
                                ' ' +
                                gtmPrefix +
                                'child-title'
                        }}"
                        [attr.data-gtmlabel]="child.title"
                    >
                        {{ child.title }}
                    </a>
                </div>
            </span>
        </div>

        <div class="fake-view" #fakeView></div>
    </div>
</span>
